import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';

import { useRepository } from '@/Application/Providers/Repository';
import type { RootState } from '@/Infrastructure/State';
import { getCart } from '@/modules/cart/application/getCart';

export const selectCartData = createSelector(
  (state: RootState) => state.cart,
  (cart) => ({
    data: cart?.data,
    isLoading: cart?.isLoading,
    error: cart?.error
  })
);

const useCart = () => {
  const { cart: cartRepository } = useRepository();
  const cartData = useSelector(selectCartData);
  const [isError, setIsError] = useState<boolean>(Boolean(cartData.error));

  useEffect(() => {
    if (cartData.error) {
      setIsError(true);
    }
  }, [cartData.error]);
  const getActiveCart = useCallback(async () => {
    const cart = await getCart(cartRepository);
    if (cart) {
      setIsError(false);
    }
    return cart;
  }, [cartRepository]);

  return {
    ...cartData,
    isError,
    refetch: getActiveCart
  };
};

export default useCart;
